import React from 'react';
import PrivacyPolicyGcc from './PrivacyPolicyGcc/PrivacyPolicyGcc';
import * as S from './PrivacyPolicy.styles';

const PrivacyPolicy = () => {
  const getCookie = cname => {
    // Region migrated to India: always report IN regardless of any ccde=AE cookie
    if (cname === 'ccde') return 'IN';
    if(typeof document !== 'undefined'){

    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
  }
    return '';
  };

  const ccdeCookie = getCookie('ccde');
  return ccdeCookie === 'AE' ? (
    <PrivacyPolicyGcc />
  ) : (
    <S.MainOuterWrap>
      <S.MainInnerWrap>
        <S.MainContentWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>Privacy Policy - MakeMyTrip</S.ConentHeadText>
            <S.ContentSubHeadText>APPLICABILITY:</S.ContentSubHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                MakeMyTrip (India) Private Limited (hereinafter “MMT”) recognizes the importance of
                privacy of its users and also of maintaining confidentiality of the information
                provided by its users as a responsible data controller and data processer.
              </S.InfoText>
              <S.InfoText>
                This Privacy Policy provides for the practices for handling and securing user's
                Personal Information (defined hereunder) by MMT and its subsidiaries and affiliates.
              </S.InfoText>
              <S.InfoText>
                This Privacy Policy is applicable to any person (‘User’) who creates a profile by
                registering on MMT website ____________________{' '}
                <strong>
                  (“myPartner Platform”) for accessing myPartner Platform and facilitating the
                  processing of booking of
                </strong>{' '}
                any product(s) or service(s) made available by MMT on{' '}
                <strong>myPartner Platform.</strong>{' '}
              </S.InfoText>
              <S.InfoText>
                For the purpose of this Privacy Policy, wherever the context so requires "you" or
                "your" shall mean User and the term "we", "us", "our" shall mean MMT. For the
                purpose of this Privacy Policy, Website means the website(s), mobile site(s) and
                mobile app(s).
              </S.InfoText>
              <S.InfoText>
                By using or accessing the <strong>myPartner Platform</strong>, the User hereby
                agrees with the terms of this Privacy Policy and the contents herein. If you
                disagree with this Privacy Policy please do not use or access our{' '}
                <strong>myPartner Platform</strong>.
              </S.InfoText>
              <S.InfoText>
                This Privacy Policy does not apply to any website(s), mobile sites and mobile apps
                of third parties, even if their websites/products are linked to our Website. User
                should take note that information and privacy practices of MMT’s business partners,
                advertisers or other sites to which MMT provides hyperlink(s), may be materially
                different from this Privacy Policy. Accordingly, it is recommended that you review
                the privacy statements and policies of any such third parties with whom they
                interact.
              </S.InfoText>
              <S.InfoText>
                This Privacy Policy is an integral part of your User Agreement with MMT and all
                capitalized terms used, but not otherwise defined herein, shall have the respective
                meanings as ascribed to them in the User Agreement.
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>USERS OUTSIDE THE GEOGRAPHICAL LIMITS OF INDIA</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                Please note that the data shared with MMT shall be primarily processed in India and
                such other jurisdictions where a third party engaged by MMT may process the data on
                MMT’s behalf. By agreeing to this policy, you are providing MMT with your explicit
                consent to process your personal information for the purpose(s) defined in this
                policy. The data protection regulations in India or such other jurisdictions
                mentioned above may differ from those of your country of residence.
              </S.InfoText>
              <S.InfoText>
                If you have any concerns in the processing your data and wish to withdraw your
                consent, you may do so by writing to the following email id:{' '}
                <strong>privacy@go-mmt.com</strong>. However, if such processing of data is
                essential for us, then we may not be able to serve after your withdrawal of consent.
              </S.InfoText>
              <S.InfoText>
                A withdrawal of consent by you for us to process your information may severely
                inhibit our ability to serve you properly.
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>TYPE OF INFORMATION WE COLLECT AND ITS LEGAL BASIS</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                <strong>"Personal Information"</strong> of User shall include the information shared
                by the User and collected by us for the following purposes:
              </S.InfoText>
              <S.InfoText>
                <strong>Registration on the myPartner Platform:</strong> Information which you
                provide while registering on the myPartner Platform, including but not limited to
                information about your personal identity such as name, gender, age etc., your
                contact details such as your email address, postal addresses, telephone (mobile or
                otherwise) and/or fax numbers. The information may also include information such as
                your banking details (including credit/debit card) and any other information
                relating to your income etc. (as shared by you).
              </S.InfoText>
              <S.InfoText>
                <strong>Other information:</strong> We may also collect some other information and
                documents including but not limited to:
              </S.InfoText>
              <S.InfoList>
                <li>
                  Booking history (other than banking details) and other details of transactions
                  whose booking is processed by you.
                </li>
                <li>
                  Your usernames, passwords, email addresses and other security-related information.
                </li>
                <li>
                  Data either created by you and which you wish to store on our servers such as
                  image files, documents etc.
                </li>
                <li>
                  Any Information shared by you disclosed to us including but not limited to
                  information to be shared by us with the ultimate service provider(s).
                </li>
              </S.InfoList>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>HOW WE USE YOUR PERSONAL INFORMATION:</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                The Personal Information collected maybe used in the following manner:
              </S.InfoText>
              <S.InfoTextBold>While making a booking</S.InfoTextBold>
              <S.InfoText>
                While making a booking, we may use Personal Information as shared to complete your
                bookings processed by you expeditiously.
              </S.InfoText>
              <S.InfoTextBold>
                We may also use the Information provided by you for several reasons including but
                not limited to:
              </S.InfoTextBold>
              <S.InfoList>
                <li>confirm the reservations with respective service providers;</li>
                <li>send booking confirmations by any mode of communication;</li>
                <li>send any updates or changes to the booking(s);</li>
                <li>allow our customer service to contact you, if necessary;</li>
                <li>customize the content of our myPartner Platform;</li>
                <li>send verification message(s) or email(s);</li>
                <li>
                  Validate and to prevent any misuse or abuse of your account on mypartner platform;
                </li>
                <li>
                  Pitch other products or business opportunities by us, our affiliate or associate
                  entities.
                </li>
              </S.InfoList>
              <S.InfoTextBold>Surveys:</S.InfoTextBold>
              <S.InfoText>
                We value opinions and comments from our Users and frequently conduct surveys, both
                online and offline. Participation in these surveys is entirely optional. Typically,
                the information received is aggregated, and used to make improvements to myPartner
                Platform and to develop appealing content and features for Users based on the
                results of the surveys. Identity of the survey participants is anonymous unless
                otherwise stated in the survey.
              </S.InfoText>
              <S.InfoTextBold>Marketing Promotions, Research and Programs:</S.InfoTextBold>
              <S.InfoText>
                Marketing promotions, research and programs help us to identify your preferences,
                develop programs and improve user experience. Personal Information collected by us
                for such activities may include contact information and survey questions. We use
                such Personal Information to develop promotions and product improvements. In
                addition, you may look forward to receiving periodic marketing emails, newsletters
                and exclusive promotions. From time to time we may add or enhance services made
                available on the myPartner Platform. To the extent these services used by you, we
                will use the Personal Information you provide to facilitate the service(s)
                requested.
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>HOW LONG DO WE KEEP YOUR PERSONAL INFORMATION?</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                MMT will retain your Personal Information on its servers for as long as is
                reasonably necessary for the purposes listed in this policy. In some circumstances
                we may retain your Personal Information for longer periods of time, for instance
                where we are required to do so in accordance with any legal, regulatory, tax or
                accounting requirements.
              </S.InfoText>
              <S.InfoText>
                Where your personal data is no longer required we will ensure it is either securely
                deleted or stored in a way which means it will no longer be used by the business.
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>COOKIES AND SESSION DATA</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoTextBold>Cookies:</S.InfoTextBold>
              <S.InfoText>
                MMT uses cookies to personalize your experience on the myPartner Platform and any
                advertisements that may be displayed.
              </S.InfoText>
              <S.InfoText>
                Cookies are small pieces of information that are stored by your browser on your
                device's hard drive. Cookies allow us to serve you better and more efficiently.
                Cookies also allow ease of access, by logging you in without having to type your
                login name each time (only your password is needed); we may also use such cookies to
                display any advertisement(s).
              </S.InfoText>
              <S.InfoText>
                Most web browsers automatically accept cookies. Of course, by changing the options
                on your web browser or using certain software programs, you can control how and
                whether cookies will be accepted by your browser.
              </S.InfoText>
              <S.InfoText>
                MMT supports your right to block any unwanted internet activity, especially that of
                unscrupulous websites.
              </S.InfoText>
              <S.InfoText>
                However, blocking MMT cookies may disable certain features on the Website, and may
                hinder an otherwise seamless experience to book or use certain services available on
                the myPartner Platform. Please note that it is possible to block cookie activity
                from certain websites while permitting cookies from websites you trust.
              </S.InfoText>
              <S.InfoTextBold>Automatic Logging of Session Data:</S.InfoTextBold>
              <S.InfoText>
                Each time you access the myPartner platform your session data gets logged. Session
                data may consist of various aspects like the IP address, operating system and type
                of browser software being used and the activities conducted by the User while on the
                Website.
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>WITH WHOM YOUR PERSONAL INFORMATION IS SHARED</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoTextBold>Service Providers and suppliers:</S.InfoTextBold>
              <S.InfoText>
                The information provided by you shall be shared with the end service providers like
                airlines, hotels, bus service providers, cab rental, railways or any other suppliers
                who are responsible for fulfilling your booking. You may note that while processing
                a booking for MMT you authorize us to share the information with the said service
                providers and suppliers. It is pertinent to note that MMT does not authorize the end
                service provider to use your information for any other purpose(s) except as may be
                for fulfilling their part of service. However, how the said service
                providers/suppliers use the information shared with them is beyond the purview and
                control of MMT as they process Personal Information as independent data controllers,
                and hence we cannot be made accountable for the same. You are therefore advised to
                review the privacy policies of the respective service provider or supplier whose
                services you book on myPartner Platform.
              </S.InfoText>
              <S.InfoTextBold>COMPANIES IN THE SAME GROUP:</S.InfoTextBold>
              <S.InfoText>
                In the interests of improving personalization and efficiency, we may, under
                controlled and secure circumstances, share your Personal Information with our
                affiliate or associate entities. This will enable us to provide you with information
                about various products and services.
              </S.InfoText>
              <S.InfoText>
                If the assets of MMT are acquired, any and all information may also be transferred
                to the acquirer depending upon the nature of such acquisition. In addition, as part
                of business expansion/development/restructuring or for any other reason whatsoever,
                if we decide to sell/transfer/assign our business, any part thereof, any of our
                subsidiaries or any business units, then as part of such restructuring exercise the
                information including the Personal Information collected herein shall be transferred
                accordingly.
              </S.InfoText>
              <S.InfoTextBold>BUSINESS PARTNERS and THIRD-PARTY VENDORS:</S.InfoTextBold>
              <S.InfoText>
                We may also share certain filtered Personal Information to our corporate affiliates
                or business partners who may contact to offer certain products or services, which
                may include free or paid products / services. MMT may share your Personal
                Information to third party that MMT may engage to perform certain tasks on its
                behalf, including but not limited to payment processing, data hosting, and data
                processing platforms.
              </S.InfoText>
              <S.InfoText>
                We use non-identifiable Personal Information of Users in aggregate or anonymized
                form to build higher quality, more useful online services by performing statistical
                analysis of the collective characteristics and behavior of our User’s, and by
                measuring demographics and interests regarding specific areas of the Website. We may
                provide anonymous statistical information based on this data to suppliers,
                advertisers, affiliates and other current and potential business partners. We may
                also use such aggregate data to inform these third parties as to the number of
                people who have seen and clicked on links to their websites. Any Personal
                Information which we collect and which we may use in an aggregated format is our
                property. We may use it, in our sole discretion and without any compensation to you,
                for any legitimate purpose including without limitation the commercial sale thereof
                to third parties.
              </S.InfoText>
              <S.InfoText>
                Occasionally, MMT will hire a third party for market research, surveys etc. and will
                provide information to these third parties specifically for use in connection with
                these projects. The information (including aggregate cookie and tracking
                information) we provide to such third parties, alliance partners, or vendors are
                protected by confidentiality agreements and such information is to be used solely
                for completing the specific project, and in compliance with the applicable
                regulations.
              </S.InfoText>
              <S.InfoTextBold>DISCLOSURE OF INFORMATION</S.InfoTextBold>
              <S.InfoText>
                In addition to the circumstances described above, MMT may disclose User's Personal
                Information if required to do so:
              </S.InfoText>
              <S.InfoList>
                <li>
                  by law, required by any enforcement authority for investigation, by court order or
                  in reference to any legal process;
                </li>
                <li>to conduct our business;</li>
                <li>for regulatory, internal compliance and audit exercise(s)</li>
                <li>to secure our systems; or</li>
                <li>
                  to enforce or protect our rights or properties of MMT or any or all of its
                  affiliates, associates, employees, directors or officers or when we have reason to
                  believe that disclosing Personal Information of User(s) is necessary to identify,
                  contact or bring legal action against someone who may be causing interference with
                  our rights or properties, whether intentionally or otherwise, or when anyone else
                  could be harmed by such activities.
                </li>
              </S.InfoList>
              <S.InfoText>
                Such disclosure and storage may take place without your knowledge. In that case, we
                shall not be liable to you or any third party for any damages howsoever arising from
                such disclosure and storage.
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>
              HOW CAN YOU OPT-OUT OF RECEIVING OUR PROMOTIONAL E-MAILS?
            </S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                You will occasionally receive e-mail updates from us about the promotions and offers
                of MMT services, and other noteworthy items. We hope you will find these updates
                interesting and informative. If you wish not to receive them, please click on the
                "unsubscribe" link or follow the instructions in each e-mail message.
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>HOW WE PROTECT YOUR PERSONAL INFORMATION?</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                All the information on the myPartner Platform are secured. This means all Personal
                Information you provide is transmitted using TLS (Transport Layer Security)
                encryption. TSL is a proven coding system that lets your browser automatically
                encrypt, or scramble, data before you send it to us. Website has stringent security
                measures in place to protect the loss, misuse, and alteration of the information
                under our control. Whenever you change or access your account information, we offer
                the use of a secure server. Once your information is in our possession we adhere to
                strict security guidelines, protecting it against unauthorized access.
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>WITHDRAWAL OF CONSENT AND PERMISSION</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                You may withdraw your consent to submit any or all Personal Information or decline
                to provide any permissions on its Website as covered above at any time. In case, you
                choose to do so then your access to the Website may be limited, or we might not be
                able to provide the services to you. You may withdraw your consent by sending an
                email to <a href="mailto:privacy@go-mmt.com">privacy@go-mmt.com</a>
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>YOUR RIGHTS QUA PERSONAL INFORMATION</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                You may access the Personal Information from your registered account with MMT on
                myPartner Platform. You may also correct your personal information or delete such
                information (except some mandatory fields) from your registered account directly. If
                you don't have such a user account, then you write to{' '}
                <a href="mailto:privacy@go-mmt.com">privacy@go-mmt.com</a>
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>ELIGIBILITY TO TRANSACT WITH MMT</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                You must atleast 18 years of age to transact directly with MMT and also to consent
                to the processing of your personal data.
              </S.InfoText>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
          <S.ContentInnerWrap>
            <S.ConentHeadText>CHANGES TO THE PRIVACY POLICY</S.ConentHeadText>
            <S.InfoContentWrap>
              <S.InfoText>
                We reserve the rights to revise the Privacy Policy from time to time to suit various
                legal, business and customer requirement. We will duly notify the users as may be
                necessary.
              </S.InfoText>
              <S.InfoTextBold>
                You may always submit concerns regarding this Privacy Policy via email to us at{' '}
                <a href="mailto:privacy@go-mmt.com">privacy@go-mmt.com</a> . MMT shall endeavor to
                respond to all reasonable concerns and inquires.
              </S.InfoTextBold>
            </S.InfoContentWrap>
          </S.ContentInnerWrap>
        </S.MainContentWrap>
      </S.MainInnerWrap>
    </S.MainOuterWrap>
  );
};

export default PrivacyPolicy;
